// extracted by mini-css-extract-plugin
export default {"menu":"SortMenu_menu__EJ706","titleContainer":"SortMenu_titleContainer__S3RZ1","eraser":"SortMenu_eraser__f4lPZ"};